import { Link, useLocation } from 'react-router-dom';
import { Hammer, ArrowLeft } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader';

export function ComingSoonPage({ title }: { title?: string }) {
  const { pathname } = useLocation();
  const label =
    title ??
    pathname
      .split('/')
      .filter(Boolean)
      .pop()
      ?.replace(/-/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase()) ??
    'This page';

  return (
    <div className="min-h-screen pb-24">
      <PageHeader section={label} backHref="/" backLabel="Home" />
      <main className="max-w-lg mx-auto px-4 py-16 flex flex-col items-center text-center">
        <div className="p-4 rounded-2xl bg-secondary mb-4">
          <Hammer className="w-8 h-8 text-muted-foreground" />
        </div>
        <h2 className="text-lg font-bold text-foreground">{label} is coming soon</h2>
        <p className="text-sm text-muted-foreground mt-2 max-w-xs">
          This section of wellKept hasn't been built yet.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-4 py-2.5 rounded-xl bg-primary text-primary-foreground text-sm font-medium"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
      </main>
    </div>
  );
}
